<template>
  <div
    v-if="activeJobReviews.length > 0"
    class="i-what-people-say"
  >
    <Carousel
      :autoplay="30000"
      :items-to-scroll="1"
      :items-to-show="isDesktop ? 2 : 1"
      class="reviews-carousel"
      pause-autoplay-on-hover
      wrap-around
      snap-align="start"
    >
      <Slide
        v-for="(review, index) in activeJobReviews"
        :key="index"
      >
        <div class="card">
          <div class="header">{{ review.persona }}</div>
          <div class="text">{{ review.review }}</div>
        </div>
      </Slide>
      <template #addons>
        <navigation>
          <template #next>
            <span>
              <img
                :src="iconArrowRightGray"
                alt="next-icon"
              />
            </span>
          </template>
          <template #prev>
            <span>
              <img
                :src="iconArrowLeftGray"
                alt="prev-icon"
              />
            </span>
          </template>
        </navigation>
      </template>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import { Carousel, Navigation, Slide } from "vue3-carousel"
import { useReportStore } from "@/stores/report"
import { breakpointLg } from "@/styles/variables"

import useIsScreenSize from "@/composables/useIsScreenSize"

// ICONS
import iconArrowRightGray from "@/assets/icons/icon-arrow-right-gray.svg"
import iconArrowLeftGray from "@/assets/icons/icon-arrow-left-gray.svg"

// STORES AND COMPOSABLES
const reportStore = useReportStore()
const isDesktop = useIsScreenSize(breakpointLg)

// COMPUTED
const activeJobReviews = computed(() => {
  // Have the longest review show first for better UI
  const deepClone = JSON.parse(JSON.stringify(reportStore.getActiveJobReviews))
  return deepClone.sort((a: any, b: any) => b.review.length - a.review.length)
})
</script>

<style lang="scss" scoped>
.i-what-people-say {
  @include flex($direction: column, $justify: center, $align: center);

  margin: 30px 0 0;

  .reviews-carousel {
    width: calc(100% - 25px);

    @media screen and (min-width: $breakpoint-sm) {
      width: 100%;
    }

    .card {
      @include flex(column, $justify: start, $align: start, $gap: 15px);

      width: 100%;
      height: 100%;
      padding: 24px;

      @include border-radius-lg;

      background-color: $white;
      border: 1px solid $zumthor100;
      text-align: start;
      cursor: pointer;

      @media screen and (min-width: $breakpoint-sm) {
        margin: 0 8px;
      }

      .header {
        @include text-lg;

        font-weight: 700;
        color: $pickle-bluewood900;

        @media screen and (min-width: $breakpoint-sm) {
          @include text-md;
        }
      }

      .text {
        @include text-sm;

        font-weight: 400;
        letter-spacing: 0;
        color: $comet600;
      }
    }
  }
}
</style>

<style lang="scss">
.i-what-people-say {
  /* stylelint-disable */
  .carousel__next,
  .carousel__prev {
    width: 15px;
    margin: 0 -18px;
  }
  /* stylelint-enable */
}

@media print {
  .i-what-people-say {
    padding-top: 50px;

    .reviews-carousel {
      .card {
        margin: 0 8px;
      }
    }
  }
}
</style>
